import { useTheme as useThemeContext } from '@/components/providers/ThemeProvider';

export function useTheme() {
  const { theme, toggleTheme } = useThemeContext();

  return {
    theme,
    toggleTheme,
    isDark: theme === 'dark',
    isLight: theme === 'light',
  };
}
